import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(Vuex)

Vue.use(VueAxios, axios)

const account = {
  state: {
    // 使用者資料
    userName: null,
    userAKID: null,
    userToken: null,
  },
  mutations: {
    getUserToken(state) {
      const userToken = sessionStorage.getItem('user_token')
      if (userToken === null) {
        const VisitorsToken = 'cpes45ptbEOPrupKQ2b1kA'  //5TkWM8kSKk2AbeJjbJXWCB  cpes45ptbEOPrupKQ2b1kA
        sessionStorage.setItem('user_token', VisitorsToken)
        sessionStorage.setItem('AC_NAME', '訪客')
        sessionStorage.setItem('AC_AKID', 0)
        state.userToken = sessionStorage.getItem('user_token')
        state.userName = sessionStorage.getItem('AC_NAME')
        state.userAKID = sessionStorage.getItem('AC_AKID')
      } else {
        state.userToken = userToken
        state.userName = sessionStorage.getItem('AC_NAME')
        state.userAKID = sessionStorage.getItem('AC_AKID')
      }
    },
  },
  actions: {
  },
  getters:{
  }
}


export default new Vuex.Store({
  modules: {
    accountModule: account
  }
})
